import RequestManager from "@/script/request"
import config from "@/config";

export default class ParcoursDeSoin {

    static async getList() {
        const urlGetList = `${config.urlBackEnd}GetList`;
        try {
            const response = await RequestManager.get(urlGetList);
            return response;
        } catch (error) {
            console.error("Erreur lors de la récupération de la liste :", error);
            throw error;
        }
    }

    // Options de parcours valides selon l'etat courant (patient/actes/specialite cote serveur).
    // ctx : { valeurActuelle, jeSuisMedecinTraitant, autreMedecinTraitant, aucunMedecinTraitant,
    //         enAME, regimeAccident, dateFse }
    // Renvoie { options:[...], defaut:"..." } (le backend sort en PascalCase -> on gere les 2 cote appelant).
    static async getOptions(ctx) {
        const url = `${config.urlBackEnd}FSE/getOptionsParcours`;
        return RequestManager.post(url, ctx || {});
    }

    // Enregistre le parcours choisi (libelle) cote serveur (mappe vers l'enum + calcule topMT/IPS).
    // payload : ctx + { caption } (ctx porte desormais nomOriente/prenomOriente)
    static async setChoix(payload) {
        const url = `${config.urlBackEnd}FSE/setParcours`;
        return RequestManager.post(url, payload || {});
    }

    // Liste des confreres (medecins adresseurs) filtree par debut de nom.
    // Renvoie [{ nom, prenom }] (backend PascalCase possible -> normalise cote appelant).
    static async getListeOriente(entree) {
        const url = `${config.urlBackEnd}Param/getListeOriente`;
        return RequestManager.post(url, { entree: entree || '' });
    }

    // Supprime un confrere de la table (touche Suppr du desktop). Renvoie { success }.
    static async supprimerConfrere(nom, prenom) {
        const url = `${config.urlBackEnd}Param/supprimerConfrere`;
        return RequestManager.post(url, { nom: nom || '', prenom: prenom || '' });
    }
}
